import {Component, OnInit, ViewChild} from '@angular/core';
import {environment} from '../../../../../../environments/environment';
import {AuthService} from '../../../../../services/auth/auth.service';
import {UserModel} from '../../../../../models/user.model';
import {ToastsService} from '../../../../../services/toasts.service';
import {StatusGroupsService} from '../../../../../services/status-groups/status-groups.service';
import {ClientsService} from '../../../../../services/clients/clients.service';
import {ParcelsService} from '../../../../../services/parcels/parcels.service';
import {ExportService} from '../../../../../services/export/export.service';
import {UserRole} from "../../../../../enums/user-role";
import {ProblematicSectorService} from "../../../../../services/problematic-sector/problematic-sector.service";
import {ShipmentsListComponent} from "./shipments-list/shipments-list.component";
import {ParcelsListComponent} from "./parcels-list/parcels-list.component";

declare var UIkit: any;

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {
  lengthMenu: number[] = [25, 500, 1000, 5000];
  pageLength:number = 25;

  lastChecked: boolean = false;
  activeListType: string = 'parcels';

  criteria = {
    type: 'parcels',
    start: null,
    end: null,
    client_id: null,
    status_group_id: null,
    courier_id: '',
    locker: '',
    cod: '',
    country: null,
    out_number: null,
    internal_number: null,
    return_number: null,
    deleted: 0,
    client_name: null,
    last_status_id: null,
    processable: null,
    problem_rule_code: null,
    client_ids: null,
    client_list_filter_mode: 'include',
    problematic_sector_id: null,
  };

  countries = [
    {id: 1, name: 'Rumunia', iso_code: 'RO', value: 'Romania'},
    {id: 3, name: 'Węgry', iso_code: 'HU', value: 'Hungary'},
    {id: 4, name: 'Bułgaria', iso_code: 'BG', value: 'Bulgaria'},
  ];

  statusGroups = [];

  problemRuleCodes = [
    {
      name: 'Brak możliości naliczenia!',
      code: 'SHIPMENT_NOT_ACCOUNTED',
    },
    {
      name: 'Nie można nadać przesyłki!',
      code: 'SHIPMENT_REGISTRATION_FAILED',
    },
    {
      name: 'Brak pierwotnego rozliczenia na fakturze',
      code: 'SHIPMENT_NOT_MAIN_INVOICED',
    },
    {
      name: 'Brak zwrotnego rozliczenia na fakturze',
      code: 'SHIPMENT_NOT_AFTER_SERVICE_INVOICED',
    }
  ];

  LOCAL_STORAGE_KEY: string = 'v2-parcels-list-criteria-';

  selectedClients = [];
  clients = [];

  statusModel = {
    ids: [],
    id_status_type: null,
    when: null,
    where: 'TYCHY',
  };

  timeout = 100;
  exportUuid = null;
  exportDownloadable = false;
  subscriptions = [];
  statusTypes = [];

  problematicSectors = [];
  public userModel: UserModel = new UserModel();

  @ViewChild('shipmentsListDatatables') shipmentsListDatatables: ShipmentsListComponent;
  @ViewChild('parcelsListDatatables') parcelsListDatatables: ParcelsListComponent;

  constructor(
    private authService: AuthService,
    private toastsService: ToastsService,
    private statusGroupsService: StatusGroupsService,
    private clientsService: ClientsService,
    private parcelsService: ParcelsService,
    private exportService: ExportService,
    private problematicSectorsService: ProblematicSectorService
  ) {
  }

  ngOnInit(): void {
    this.authService.isLogged.subscribe((userModel) => {
      this.userModel = userModel;
      if (UserRole.client !== userModel.role) {
        this.problematicSectorsService.list().subscribe(
          (response: []) => {
            for (let key of Object.keys(response)) {
              this.problematicSectors.push(response[key])
            }
          }
        );
      }
    });

    this.setCriteria();
    this.statusGroupsService.list().subscribe(
      (response: []) => {
        this.statusGroups = response;
      }
    );

    setTimeout(
      (): void => {
        this.runFilters();
      },
      500,
    );

    setTimeout(
      (): void => {
        this.getStatusTypes();
      }, 500
    );

    this.setTime();
  }

  generateLocalStorageKey(): string {
    return btoa(this.LOCAL_STORAGE_KEY+this.userModel.id);
  }

  setCriteria() : void{
    const savedCriteria = localStorage.getItem(this.generateLocalStorageKey());

    if (null === savedCriteria) {
      this.criteria = {
        type: 'parcels',
        start: this.findDate(),
        end: this.findDate(),
        client_id: null,
        status_group_id: null,
        courier_id: null,
        locker: null,
        cod: null,
        country: null,
        out_number: null,
        internal_number: null,
        return_number: null,
        deleted: 0,
        client_name: null,
        last_status_id: null,
        processable: null,
        problem_rule_code: null,
        client_ids: null,
        client_list_filter_mode: 'include',
        problematic_sector_id: null,
      };

      this.activeListType = this.criteria.type;

      return;
    }

    decodeURIComponent(
      escape(
        atob(savedCriteria),
      ),
    );

    this.criteria = JSON.parse(
      decodeURIComponent(
        escape(
          atob(savedCriteria),
        ),
      ),
    );

    this.activeListType = this.criteria.type;

    if (null !== this.criteria.client_ids) {
      for (let clientId of  this.criteria.client_ids) {
          this.clientsService.getClient(clientId).subscribe(
            (clientResp: any) => {
              this.selectedClients.push({
                id: clientResp.id,
                name: clientResp.name,
              });
            }
          );
      }
    }
  }

  searchClient(input): void {
    this.clientsService.searchClient(input.value).subscribe(
      (response: Array<any>) => {
        this.clients = response;
      }
    );
  }

  getStatusTypes(): void {
    if (UserRole.client === this.userModel.role) {
      return;
    }
    this.parcelsService.findStatusTypesForWarehouseSelect().subscribe(
      (response: any) => {
        if (response.length > 0) {
          this.statusModel.id_status_type = response[0].id;
        }
        this.statusTypes = response;
      }
    );
  }

  setTime(): void {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    const hour = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    this.statusModel.when = `${year}-${month}-${day}T${hour}:${minutes}`;
  }

  setClient(client): void {
    this.clients = [];
    this.criteria.client_id = client.id;
    this.criteria.client_name = client.name;
  }

  findDate(): string {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());

    return `${year}-${month}-${day}`;
  }

  listClients: any[] = [];

  clientListClientName: string='';

  searchClientToList(input): void {
    this.clientsService.searchClient(input.value).subscribe(
      (response: Array<any>) => {
        this.listClients = response;
      }
    );
  }

  addSelectedClients(client): void {
    this.clientListClientName = '';
    this.selectedClients.push(client);
    this.listClients = [];
  }

  uncheckClientFromList(index): void{
    let newList = [];
    for (let i in this.selectedClients) {
      if (i != index) {
        newList.push(this.selectedClients[i]);
      }
    }

    this.selectedClients = newList;
  }

  runFilters(): void {
    this.activeListType = this.criteria.type;
    localStorage.setItem(
      this.generateLocalStorageKey(),
      btoa(
        unescape(
          encodeURIComponent(
            JSON.stringify(
              this.criteria,
            )
          )
        )
      )
    );

    if ('parcels' === this.activeListType) {
      this.parcelsListDatatables.showParcels();
    } else {
      this.shipmentsListDatatables.showShipments();
    }
  }

  refreshFilters(): void {
    this.criteria = {
      type: 'parcels',
      start: this.findDate(),
      end: this.findDate(),
      client_id: null,
      status_group_id: null,
      courier_id: null,
      locker: null,
      cod: null,
      country: null,
      out_number: null,
      internal_number: null,
      return_number: null,
      deleted: 0,
      client_name: null,
      last_status_id: null,
      processable: null,
      problem_rule_code: null,
      client_ids: null,
      client_list_filter_mode: 'include',
      problematic_sector_id: null,
    };

    if ('parcels' === this.activeListType) {
      this.parcelsListDatatables.cleanShowParcels();
    }
    else {
      this.shipmentsListDatatables.cleanShowShipments();
    }
  }

  downloadFile(): void {
    if (UserRole.client === this.userModel.role) {
        return this.orderStandardReport(false);
    }

    this.customReportForm.start = this.criteria.start;
    this.customReportForm.end = this.criteria.end;

    UIkit.modal('#orderReportModal').show();
  }

  orderReport(): void {
      switch (this.customReportForm.type) {
        case 'standard_from_filters':
          return this.orderStandardReport(false);
        case 'standard_from_filters_with_accounting':
          return this.orderStandardReport(true);
        default:
          return this.orderCustomReport();
      }
  }

  customReportForm = {
    type: 'standard_from_filters',
    start: null,
    end: null,
  };

  orderCustomReport(): void {
    this.exportService.orderCustomReport(
      this.customReportForm
    ).subscribe(
      (response: any): void => {
        this.toastsService.showMessage('Generowanie zestawienia przesyłek zostało zlecone!', 's');
      }
    );
  }

  orderStandardReport(reAccount: boolean): void {
    this.exportService.makeOrder({
      type: 'list',
      re_account: reAccount
    }).subscribe(
      (response: any): void => {
        this.exportUuid = response.uuid;
        const subscription = this.exportService.showByUuid(response.uuid).subscribe(
          (subResponse: any) => {
            if ('validated' === subResponse.status) {
              this.toastsService.showMessage('Twoje zestawienie jest gotowe do pobrania!', 's');
              this.exportDownloadable = true;
            }
            if ('validation_error' === subResponse.status) {
              this.toastsService.showMessage('Nie możemy wygenerować twojego zestawienia!', 'w');
              this.exportUuid = null;
            }
          },
        );

        this.subscriptions.push(subscription);
        this.toastsService.showMessage('Generowanie zestawienia przesyłek zostało zlecone!', 's');
      },
      (error): void => {
        if (error.status === 406) {
          this.toastsService.showMessage('Wygenerowanie pliku wedle zadanych kryteriów (processable) nie jest możliwy!', 'e');
        }
      }
    );
  }

  openGroupedStatus(): void {
    const modals =  document.getElementsByClassName('changeGrouppedStatus');
    if (modals.length > 1) {
      modals[1].remove();
    }
    UIkit.modal('#changeGrouppedStatus').show();
  }

  selectAll(): void {
    this.lastChecked = !this.lastChecked;
    this.parcelsListDatatables.selectAll();
  }

  setGroupStatuses(): void {
    this.statusModel.ids = [];
    for (const parcel of this.parcelsListDatatables.allParcels()) {
      if (parcel.selected == 1) {
        this.statusModel.ids.push(parcel.id);
      }
    }

    this.parcelsService.setGroupStatus(this.statusModel).subscribe(
      (response: any) => {
        this.toastsService.showMessage('Statusy przesyłek zostały zaaktualizowane pomyślnie!', 's');
        this.parcelsListDatatables.showParcels();
      }, (error: any)=>{
        if (error.status==420){
          this.toastsService.showMessage('Statusy przesyłek zostały zaaktualizowane, za wyjątkiem przesyłek o numerach '+error.error+', dla których status ten został nadany wcześniej.', 'w', 5000);
          this.parcelsListDatatables.showParcels();
        }
      }
    );
    UIkit.modal('#changeGrouppedStatus').hide();
  }

  protected readonly UserRole = UserRole;
}
